import { CalculationInfoAsBuild } from '~/app/compositions/content/calculation-info/core/calculation-info-as-build';
import { EquipmentHighlights } from '~/app/compositions/sidebar/equipment-highlights';
import { Packages } from '~/app/compositions/sidebar/package';

import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';
import { PartialUiConfiguration } from '~/app/market-config/models/car-confi-ui-configuration';
import { JETSTREAM_SERVER_US } from '~/app/models/constans';
import { ImageViewsEnum } from '~/app/pages/configurator/models/image-views';

export const local: PartialCarConfiguration = {
	hasJetStream: true,
	JetStreamServerUrl: JETSTREAM_SERVER_US,
	showCaESummaryText: false,
	engineCardKeyfacts: ['electricRanges', 'acceleration', 'speed'],
	combinations: ['trimLine', 'paint[bodyPaint]', 'rims', 'interior[covers]', 'packages', 'equipmentHighlights'],
	uiPreferences: {
		prices: {
			totalPriceFrom: 'totalWithCharges',
			hiddenPriceParts: ['totalWithCharges', 'modelPriceWithFees', 'total', 'importCharge', 'destinationCharge'],
			vatConfig: {
				feature: 'hidden',
				trimlineAndEngine: 'hidden',
				totalPrice: 'hidden',
				priceParts: {},
			},
		},
	},
	showPricesWithFees: true,
	showFinancingDisclaimerInDialogs: false,
	packagesFilter: {
		filterByFeatureState: ['available'],
		filterByFeatureTypes: {
			featureTypes: ['EQUIPMENT'],
		},
		filterByGroupIds: {
			groupIds: [],
			mode: 'EXCLUSIVE',
		},
	},
	enableFinancingServices: false,
	hideMonthlyRates: true,
	hideConsumptionEmissionEngineName: true,
	displayOnlyPackageCat: true,
	nextBestActions: [
		{
			icon: '',
			description: 'Search in available inventory',
			labelText: 'Search inventory',
			target: '_blank',
			trackingName: 'go to vtp',
			url: 'https://www.audi.ca/ca/web/en/inventory.html?filter=entry=true&carline={{carlineId}}',
		},
		{
			icon: 'dealer-request',
			description: 'Request trade-in appraisal',
			labelText: 'Request trade-in appraisal',
			target: '_blank',
			trackingName: 'request a trade-in appraisal',
			url: 'https://www.audi.ca/ca/web/en/forms/trade-in.html?dealer_id=49',
		},
		{
			icon: 'send',
			description: 'Contact dealer',
			labelText: 'Contact dealer',
			target: '_blank',

			trackingName: 'contact',
			url: 'https://www.audi.ca/ca/web/en/forms/contact-dealer.html?dealer_id=49',
		},
		{
			icon: 'test-drive',
			description: 'Book a test drive',
			labelText: 'Book a test drive',
			target: '_blank',

			trackingName: 'testdrive',
			url: 'https://www.audi.ca/ca/web/en/forms/test-drive.html?dealer_id=49',
		},
	],
	summaryFooterCta: {
		icon: 'send',
		description: 'Contact dealer',
		labelText: 'Contact dealer',
		target: '_blank',

		trackingName: 'contact',
		url: 'https://www.audi.ca/ca/web/en/forms/contact-dealer.html?dealer_id=49',
	},
};

export const local_ui: PartialUiConfiguration = {
	options: {
		equipmentHighlights: () => ({
			id: 'equipment-highlights',
			imageView: ImageViewsEnum.EXTERIOR_FRONT_FRONT,
			label: 'ngc.equipment.equipmentHighlights',
			component: <EquipmentHighlights />,
			camera: 'MRVSide',
			visible: true,
		}),
		packages: () => ({
			id: 'packages',
			label: 'ngc.equipment.packages',
			imageView: ImageViewsEnum.LIGHTS_FRONT_HEADLIGHTS,
			component: <Packages />,
			camera: 'MRV1',
			visible: true,
		}),
	},
	showAccessoriesExclusive: false,
	showAccessoriesInclusive: true,
	calculationInfoComponent: <CalculationInfoAsBuild className="calculation" />,
};
